import React from "react"
import Button from "@kit/design/button"
import { analytics } from "utils/analytics"

const TEXT = "Upgrade"

export function FreePlanUpgradeButton({ userInfo = {} }) {
  function handleClick() {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        name: "free_header_upgrade_button",
        location: "primary_nav",
        text: TEXT
      },
      { transport: "beacon" }
    )

    window.location.href = "/upgrade"
  }

  if (!userInfo.free || userInfo.trialing) {
    return null
  }

  return (
    <>
      <Button is="primary" size="sm" onClick={handleClick}>
        {TEXT}
      </Button>
    </>
  )
}
